import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useState } from 'react';
import browser from '@openclassrooms/utils/browser';
export default function useGetInitialComputedStyle(domElement) {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [elementInitialComputedStyle, setElementInitialComputedStyle] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== domElement) {
    t1 = () => {
      if (!domElement) {
        return;
      }
      const elementStyle = browser.window.getComputedStyle(domElement);
      setElementInitialComputedStyle(elementStyle);
    };
    t2 = [domElement];
    $[1] = domElement;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useLayoutEffect(t1, t2);
  return elementInitialComputedStyle;
}